import { render } from "./ClinicScheduleHistory.vue?vue&type=template&id=1f5835aa&scoped=true"
import script from "./ClinicScheduleHistory.vue?vue&type=script&lang=js"
export * from "./ClinicScheduleHistory.vue?vue&type=script&lang=js"

import "./ClinicScheduleHistory.vue?vue&type=style&index=0&id=1f5835aa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5835aa"]])

export default __exports__